export const TaskListOptions = [
  { title: 'Updated', value: 'updated_at' },
  { title: 'Oldest', value: 'oldest_open_task_datetime' },
  { title: 'Count', value: 'count' },
  { title: 'Title', value: 'name' },
];

export const TaskListAgingOptions = [
  { title: 'Updated', value: 'updated_at' },
  { title: 'Oldest', value: 'created_at' },
  { title: 'Most Recent', value: '-created_at' },
  { title: 'By Author', value: 'authors' },
  { title: 'By Assignee', value: 'assignees' },
  { title: 'By Standard', value: '-status' },
];

export const ReportListOptions = [
  { title: 'Most Relevant', value: 'relevance' },
  { title: 'Most Recent', value: '-start_date' },
  { title: 'Author', value: 'author' },
  { title: 'Title', value: 'name' },
];
